import { render, staticRenderFns } from "./SettingsWrapper.vue?vue&type=template&id=e0fbfe5c&"
import script from "./SettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./SettingsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports